/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".search-bar[_ngcontent-%COMP%], ion-searchbar[_ngcontent-%COMP%]{background:#fff;--background:white;position:relative;border-radius:20px 20px 0 0;z-index:1}ion-list[_ngcontent-%COMP%]   ion-item[_ngcontent-%COMP%]{--background:transparent}ion-list[_ngcontent-%COMP%]   ion-item[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-family:font-bold}ion-list[_ngcontent-%COMP%]   ion-icon[slot=start][_ngcontent-%COMP%]{margin-right:13px}"];
export { styles as styles };
